import { useEffect, useState } from 'react'

import classNames from 'classnames'

import './checkbox.style.css'

export const Checkbox = ({ checked = false, onChange }: Props) => {
  const [isChecked, setChecked] = useState<boolean>(false)

  useEffect(() => {
    setChecked(checked)
  }, [checked])

  const handleChange = (e: any) => {
    e.preventDefault()
    e.stopPropagation()

    onChange?.(!isChecked)
    setChecked(!isChecked)
  }

  const className = classNames('checkbox', {
    'checkbox__is-checked': isChecked,
  })

  return (
    <label className={className} onClick={handleChange}>
      <input type="checkbox" checked={isChecked} onChange={handleChange} />
      <span className="checkbox__checkmark"></span>
    </label>
  )
}

interface Props {
  checked?: boolean
  onChange?: (checked: boolean) => void
}
